<layout-base
	layoutClassName="simple-layout"
	[withContactForm]="true"
	[withThemeSelector]="true"
	[themesIsOpened]="themesIsOpened"
	(action)="handleAction($event)">

	<header id="top-bar" content-top-bar layout-top-bar
		[withThemeSelector]="true"
		[withAstonLogo]="true"
		[user]="currentUser$ | async" 
		(action)="handleAction($event)">
	</header>

	<div content-main class="col-lg-9 col-xl-8">
		<page-header/>

		<router-outlet></router-outlet>
	</div>
</layout-base>